import { staticOfacRestriction } from "@/components/CourseContent/ContentRefresh/OFACmessage/constants";
import { cn } from "@/lib/utils";

interface OFACRestrictionsProps {
  hasOfacRestrictions?: boolean;
  className?: string;
}

function OFACRestrictions({
  hasOfacRestrictions = true,
  className,
}: OFACRestrictionsProps) {
  if (hasOfacRestrictions) {
    const classes = cn(
      "flex flex-col justify-center align-center md:mb-12",
      className,
    );

    return (
      <div className={classes}>
        <h2 className="text-primary text-base md:text-3xl font-bold hidden md:block">
          {staticOfacRestriction.forType("course").trigger}
        </h2>
        <p className="text-primary text-base md:text-3xl font-bold block md:hidden mt-3">
          {staticOfacRestriction.forType("course").trigger}
        </p>
        <p>{staticOfacRestriction.forType("course").description}</p>
      </div>
    );
  }
  return null;
}

export default OFACRestrictions;
